import EmailProvider from "./EmailProvider";
import SendGrid from "./SendGrid";
import SendEmail from "./SendEmail";
import SMTP from "./SMTP";

const emailSettingsComponents = {
  EmailProvider,
  SendGrid,
  SendEmail,
  SMTP
}

export default emailSettingsComponents